// Export the Component Definition for use in Contentful Studio
export {SpacerContentfulComponentDefinition} from './spacerContentfulDefinition';
export {default} from './Spacer';
